import { createSlice } from '@reduxjs/toolkit';

const errorsSlice = createSlice({
  name: 'errors',
  initialState: {
    general: '',
    signIn: '',
  },
  reducers: {
    setSignInError: (state, action) => {
      state.signIn = action.payload;
    },
    setGeneralError: (state, action) => {
      state.general = action.payload;
    },
  },
});

export const { setSignInError, setGeneralError } = errorsSlice.actions;
export default errorsSlice.reducer;
